import { createElementBlock as o, openBlock as r, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), o("svg", n, e[0] || (e[0] = [
    t("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.566 18.582v2.778s3.367-.611 4.445-2.222c.58-.87.599-2.196.465-3.334m-10.698-3.01H3s.611-3.367 2.222-4.445c.87-.58 2.196-.6 3.334-.465m-.82 8.883-1.571-1.571-.625-.625a20.2 20.2 0 0 1 1.837-4.667 10.76 10.76 0 0 1 5.199-4.825c2.26-1.003 4.914-1.314 7.712-.903.486 3.46.349 9.4-5.665 12.92a20.6 20.6 0 0 1-4.73 1.828l-.586-.585zm0 0L6.165 18.34"
    }, null, -1)
  ]));
}
const a = { render: l };
export {
  a as default,
  l as render
};
